import BaseService from 'services/base-service';
import { IUserData, ITermsCondtionData, ISupportedLanguage, IsupportedDateAndTimeFormat } from 'models/login';
import StandardResponse from 'models/standard-response';
import axios from 'axios';

export default class LoginAPIService {
    userDetails = async (data?: { is_user_login: boolean }): Promise<IUserData> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/users/userprofile`,
                method: 'POST',
                data,
            });
            return Promise.resolve(res.data.data);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    emailNotification = async (email: string): Promise<boolean> => {
        const data = { email: email.toLowerCase(), byPassAuth: true };
        try {
            await BaseService({
                url: `/v1/admin/users/notify-password-change`,
                method: 'PUT',
                data,
            });
            return Promise.resolve(true);
        } catch (e) {
            return Promise.resolve(false);
        }
    };
    getTermsAndConditionListing = async (): Promise<StandardResponse<Array<ITermsCondtionData>>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/users/terms-and-conditions`,
                method: 'get',
            });
            return new StandardResponse<Array<ITermsCondtionData>>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    saveTermsAndCondition = async (data: any): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/users/terms`,
                method: 'POST',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getSupportedLanguages = async (): Promise<ISupportedLanguage> => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_SERVER}/v1/admin/common/languages/search`, {});
            return Promise.resolve(res.data);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getRegionConfigurations = async (): Promise<IsupportedDateAndTimeFormat> => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_SERVER}/v1/admin/common/get-region-configs`);
            return Promise.resolve(res.data);
        } catch (e) {
            return Promise.reject(e);
        }
    };
}
